
import { defineComponent, PropType, ref, onMounted } from 'vue'

import { VideoAttributes } from '@/types/models/video'
import { toArray } from '@/utils/array'
import { axios } from '@/plugins/axios'
import axiosBase from 'axios'

const fetchVimeoThumbnailUrl = async (vimeoId: string, vimeoHash: string): Promise<string | undefined> => {
  const vimeoApiUrl = `https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/${vimeoId}/${vimeoHash}`
  const response = await axiosBase.get(vimeoApiUrl)
  console.log(response.data)
  // response.data.thumbnail_urlはundefinedの可能性がある
  return response.data ? response.data.thumbnail_url : undefined
}

const updateThumbnailUrl = (videoId: number, thumbnailUrl: string) => {
  axios.post(`/video/thumbnail/${videoId}`, { thumbnail_url: thumbnailUrl })
}

export default defineComponent({
  props: {
    video: {
      type: Object as PropType<VideoAttributes | undefined>,
      'default': () => (undefined),
    },
    rounded: {
      type: Boolean,
      'default': () => (true),
    },
    titleAlign: {
      type: String,
      'default': () => ('text-left'),
    },
  },
  setup(props) {
    const thumbnailUrl = ref<string | undefined>(undefined)

    const getThumbnailUrl = async (video: VideoAttributes | undefined): Promise<string | undefined> => {
      if (video) {
        if (video.thumbnail_url) return video.thumbnail_url
  
        if (video.video_vimeo) {
          const thumbnailUrl = await fetchVimeoThumbnailUrl(video.video_vimeo.vimeo_id, video.video_vimeo.vimeo_hash)
          if (thumbnailUrl) updateThumbnailUrl(video.id, thumbnailUrl) //初回のみVimeoAPIを叩きたいためDBに保存する
          return thumbnailUrl
        }
      }

      return undefined
    }

    onMounted(async () => {
      thumbnailUrl.value = await getThumbnailUrl(props.video)
    })

    return {
      toArray,
      thumbnailUrl,
    }
  },
})
